export default __webpack_public_path__ + "static/inventory-optimisation-2--mobile-9a55c88095a52639096164aed36f5b1a.png";